/**
 * Play a short notification sound (e.g. when a live Reverb notification arrives).
 * Uses Web Audio API; no external audio file required.
 * May be muted until the user has interacted with the page (browser autoplay policy).
 */
export const playNotificationSound = (): void => {
	try {
		const AudioContextClass = window.AudioContext ?? (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext;
		if (!AudioContextClass) return;

		const audioContext = new AudioContextClass();
		const oscillator = audioContext.createOscillator();
		const gainNode = audioContext.createGain();

		oscillator.connect(gainNode);
		gainNode.connect(audioContext.destination);

		oscillator.frequency.value = 800;
		oscillator.type = "sine";
		gainNode.gain.setValueAtTime(0.25, audioContext.currentTime);
		gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.15);

		oscillator.start(audioContext.currentTime);
		oscillator.stop(audioContext.currentTime + 0.15);
	} catch {
		// Ignore when AudioContext is not supported or blocked (e.g. autoplay policy)
	}
};
